/* «Досье бойца»: клик по примете переключает главное фото товара на этот ракурс. Версия неизменяема. */
(function () {
  'use strict';
  // SEO-описание остаётся в HTML, но под досье сворачивается: его первый абзац совпадает с лидом досье.
  function foldDescription() {
    var dossier = document.querySelector('.gos-dossier');
    var description = dossier && dossier.closest('.product__info-container') &&
      dossier.closest('.product__info-container').querySelector('.product__description');
    if (!description || description.classList.contains('gos-dossier-desc')) return;
    description.classList.add('gos-dossier-desc');
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'gos-dossier-desc__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.textContent = 'Подробнее о модели';
    toggle.addEventListener('click', function () {
      var open = description.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.textContent = open ? 'Свернуть' : 'Подробнее о модели';
    });
    description.insertAdjacentElement('afterend', toggle);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', foldDescription);
  else foldDescription();
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('.gos-dossier__mark[data-media]');
    if (!button) return;
    var gallery = document.querySelector('media-gallery[id^="MediaGallery-' + (button.closest('.gos-dossier').dataset.section || '') + '"]') ||
      document.querySelector('media-gallery');
    if (!gallery || typeof gallery.setActiveMedia !== 'function') return;
    if (!gallery.querySelector('[data-media-id="' + button.dataset.media + '"]')) return;
    gallery.setActiveMedia(button.dataset.media, false);
    var rect = gallery.getBoundingClientRect();
    if (rect.top < 0 || rect.top > window.innerHeight * 0.5) {
      gallery.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
    }
  });
})();
